import {
  GetSocialAnalyticsSummaryWithPreviousPeriodQuery,
  PostInsights,
  MemberInsights,
} from '@frontend/gql/social/graphql';
import { DateType, MetricType } from '../types';

interface UseSummaryTabProps {
  data: GetSocialAnalyticsSummaryWithPreviousPeriodQuery | undefined;
  fetching: boolean;
  startDate?: string;
  endDate?: string;
  dateType?: DateType;
  clientId?: string;
  topPosts?: PostInsights[];
  topPostsFetching?: boolean;
  topCreators?: MemberInsights[];
  topCreatorsFetching?: boolean;
  selectedPostMetric: MetricType;
  setSelectedPostMetric: (metric: MetricType) => void;
  selectedCreatorMetric: MetricType;
  setSelectedCreatorMetric: (metric: MetricType) => void;
  initialized: boolean;
}

interface UseSummaryTabReturn {
  summaryTabProps: {
    data: GetSocialAnalyticsSummaryWithPreviousPeriodQuery | undefined;
    isLoading: boolean;
    startDate?: string;
    endDate?: string;
    dateType?: DateType;
    clientId?: string;
    topPosts?: PostInsights[];
    topPostsFetching?: boolean;
    topCreators?: MemberInsights[];
    topCreatorsFetching?: boolean;
    selectedPostMetric: MetricType;
    setSelectedPostMetric: (metric: MetricType) => void;
    selectedCreatorMetric: MetricType;
    setSelectedCreatorMetric: (metric: MetricType) => void;
    initialized: boolean;
  };
}

export const useSummaryTab = ({
  data,
  fetching,
  startDate,
  endDate,
  dateType,
  clientId,
  topPosts,
  topPostsFetching,
  topCreators,
  topCreatorsFetching,
  selectedPostMetric,
  setSelectedPostMetric,
  selectedCreatorMetric,
  setSelectedCreatorMetric,
  initialized,
}: UseSummaryTabProps): UseSummaryTabReturn => {
  return {
    summaryTabProps: {
      data,
      isLoading: fetching,
      startDate,
      endDate,
      dateType,
      clientId,
      topPosts,
      topPostsFetching,
      topCreators,
      topCreatorsFetching,
      selectedPostMetric,
      setSelectedPostMetric,
      selectedCreatorMetric,
      setSelectedCreatorMetric,
      initialized,
    },
  };
};
